import { stringIncludesIgnoreCase } from "../../utils/comparisons";
import { UserFilter } from "./userTypes";
import { UserNoPassword } from "../../api/api-types";

export const signupsHandlerMiddleware = (
  name: string,
  value: string,
  state: any
) => {
  return {};
};

export const userValidator = (item: any) => {
  if (!item.name) return false;
  if (!item.email) return false;
  if (!item.company) return false;
  return true;
};

export const userValidatorFromScratch = (item: any) => {
  if (!item.name) return false;
  if (!item.email) return false;
  if (!item.company) return false;
  if (!item.role) return false;
  return true;
};

export const filterUserItem = (
  item: UserNoPassword,
  filters: UserFilter
): boolean => {
  if (
    filters.company &&
    !stringIncludesIgnoreCase(
      item.company.companyName,
      filters.company.companyName
    )
  )
    return false;
  if (filters.name && !stringIncludesIgnoreCase(item.name, filters.name))
    return false;
  if (filters.email && !stringIncludesIgnoreCase(item.email, filters.email))
    return false;
  return true;
};

export const userMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (autoboxLabel && autoboxLabel === "company")
    return { company: autoboxValue };
  else return {};
};
